// import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section className="my-12 md:my-24" style={{ marginTop: '3rem', marginBottom: '3rem', backgroundColor: 'transparent' }}>
      <div className="container mx-auto px-4" style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Event Image - Now at the top */}
        <div className="mb-8 md:mb-16">
          <div className="max-w-6xl mx-auto">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img 
                src="/assets/about/TDA2024_182.jpg" 
                alt="Tanzania Digital Awards 2024 Event" 
                className="w-full h-[200px] md:h-[400px] object-cover"
              />
            </div>
          </div>
        </div>

        {/* Section Header - Between image and content */}
        <div className="text-center mb-8 md:mb-16" style={{ marginTop: '1.5rem' }}>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 md:mb-6">
            Digital Excellence in Tanzania
          </h2>
        </div>

        {/* Content Section with Trophy and Text */}
        <div className="max-w-6xl mx-auto" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div className="rounded-2xl p-6 md:p-12" style={{ padding: '1.5rem', borderRadius: '1rem', backgroundColor: 'transparent' }}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center" style={{ display: 'grid', gap: '2rem', alignItems: 'center' }}>
              
              {/* Left Column - Trophy Image */}
              <div className="flex justify-center lg:justify-start" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div className="relative overflow-hidden rounded-2xl shadow-xl" style={{ borderRadius: '1rem', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)' }}>
                  <img 
                    src="/assets/about/tda2.png" 
                    alt="TDA Trophy Winner" 
                    className="w-full max-w-xs md:max-w-md h-auto object-cover"
                    style={{ width: '100%', maxWidth: '20rem', height: 'auto', objectFit: 'cover', display: 'block' }}
                  />
                </div>
              </div>

              {/* Right Column - Content */}
              <div className="space-y-6 md:space-y-8 text-left" style={{ textAlign: 'left' }}>
                <h3 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-900">
                  Tanzania Digital Awards
                </h3>
                
                <div className="space-y-4 md:space-y-8" style={{ marginTop: '1.5rem' }}>
                  <p className="text-gray-700 text-base md:text-lg leading-relaxed" style={{ textAlign: 'justify', lineHeight: '1.8', marginBottom: '1rem' }}>
                    Established in 2020, the Tanzania Digital Awards honours creativity, innovation and efficacy 
                    in harnessing digital space for positive societal changes in Tanzania.
                  </p>
                  
                  <p className="text-gray-700 text-base md:text-lg leading-relaxed" style={{ textAlign: 'justify', lineHeight: '1.8' }}>
                    Tanzania Digital Awards is an initiative that seeks to extend recognition to individuals and 
                    organizations who make effective use of digital technologies to creatively and innovatively 
                    inspire actions, bring change and foster lasting impact across and beyond the online community 
                    using and through digital platforms and technologies.
                  </p>
                </div>

                {/* <div className="pt-2 md:pt-4">
                  <Link 
                    to="/about" 
                    className="inline-flex items-center px-6 py-3 md:px-8 md:py-4 bg-blue-900 text-white rounded-full font-semibold text-base md:text-lg hover:bg-blue-800 transition-colors duration-300 group"
                  >
                    Learn More 
                    <i className="fa-solid fa-arrow-right ml-2 md:ml-3 group-hover:translate-x-1 transition-transform duration-300"></i>
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
